class Covidence.Promotion extends Covidence.RelationalModel

class Covidence.Promotions extends Covidence.Collection
  model: Covidence.Promotion

